import styled from 'styled-components'

export const StyledSelect = styled.select`
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  height: 40px;
  color: ${props => props.theme.form.fontColor};
  font-size: 16px;
  line-height: 22px;
  margin: 0;
  padding: 8px 42px 8px 12px;
  border-color: ${props => props.theme.form.passiveColor};
  border: 1px solid ${props => props.theme.form.passiveColor};
  border-radius: ${props => props.theme.form.borderRadius};
  background: ${props => props.theme.form.inputBackgroundColor};
  box-sizing: border-box;
  box-shadow: none;
  appearance: none;
  transition: background-color 300ms ease, border-color 300ms ease, color 300ms ease;

  &:focus {
    box-shadow: ${props => props.theme.form.boxShadow};
    outline: 0;
  }

  &[disabled] {
    cursor: not-allowed;
    background-color: ${props => props.theme.form.inputDisabledBackgroundColor};
    color: ${props => props.theme.form.passiveColor};
  }

  &[readonly] {
    background-color: ${props => props.theme.form.inputDisabledBackgroundColor};
    border-color: ${props => props.theme.form.passiveColor};
  }
`

export const Container = styled.div<any>`
  position: relative;

  .select-arrow-expand {
    opacity: 1;
    pointer-events: none;
    position: absolute;
    right: 10px;
    top: 31px;
    width: 20px;
    height: 20px;
    fill: ${props => props.theme.form.indicatorColor};
    background: ${props => props.theme.form.inputBackgroundColor};
    box-shadow: -10px 0 3px -3px ${props => props.theme.form.inputBackgroundColor};
    transition: opacity 200ms ease;
    ${props => props.isLoading && `
      opacity: 0;
    `}

    ${props => props.isDisabled && `
      opacity: 0;
    `}
  }
`

StyledSelect.displayName = 'StyledSelect'
